import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../../../router/all_routes";
import Cookies from "js-cookie";
import { useUserPermissions } from "../../../../UserPermissionsContext";
import DualListBox from "../../../../duallistBox";
import { Toast } from "react-bootstrap";

interface Option {
  value: number;
  label: string;
}
type DualList = { id: number; name: string };

interface ErrorMessages {
  name?: string[];
}

const AddTeamManager = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const jwtToken = Cookies.get("authToken");
  const { userPermissions, webApi } = useUserPermissions();
  const [isLoading, setIsLoading] = useState(false);
  const [managerName, setManagerName] = useState<string>("");
  const [teamManagers, setTeamManagers] = useState<DualList[]>([]);
  const [chosenTeamManagers, setChosenTeamManagers] = useState<DualList[]>([]);
  const [showSolidDangerToast, setShowSolidDangerToast] = useState(false);
  const [showSolidSuccessToast, setshowSolidSuccessToast] = useState(false);
  const handleSolidSuccessToastClose = () => setshowSolidSuccessToast(false);
  const handleSolidDangerToastClose = () => setShowSolidDangerToast(false);
  const [errorMessage, setErrorMessage] = useState<ErrorMessages>({});
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    if ((showSolidDangerToast || showSolidSuccessToast) === true) {
      setTimeout(() => setShowSolidDangerToast(false), 5000);
      setTimeout(() => setshowSolidSuccessToast(false), 5000);
    }
  }, [toastMessage]);
  const checkPermission = (action: any, subject: any) => {
    return userPermissions.some(
      (ability) => ability.action === action && ability.subject === subject,
    );
  };

  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwtToken}`,
    },
  };

  const fetchTeamMembers = async () => {
    const response = await fetch(
      `${webApi}/sed/users_dropdown_for_sed_team_managers/`,
      options,
    );

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === "token_not_valid") {
        navigate("/academic/sri-chaitanya/crm/landing-page");
      }
      throw new Error(
        errorData.detail || "Failed to fetch SED Managers List data",
      );
    }

    const data = await response.json();

    const mapped: DualList[] = data.map((item: any) => ({
      id: item.id,
      name: item.name,
    }));

    setTeamManagers(mapped);
  };

  const handleTeamManagerChange = (selected: DualList[]) => {
    setChosenTeamManagers(selected);
  };

  useEffect(() => {
    if (!checkPermission("add_sedmanagers", "sedmanagers")) {
        navigate(routes.crmLandingPage)
    } else {
      fetchTeamMembers();
    }
  }, [userPermissions]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    const finalData = {
      name: managerName,
      is_active : true,
      managers : chosenTeamManagers.map(permission => permission.id),
    };

    try {
      setIsLoading(true);
      const response = await fetch(`${webApi}/sed/sed_team_managers/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(finalData),
      });
      if (!response.ok) {
        const errorData = await response.json();
        setErrorMessage(errorData);
        setToastMessage(errorData.name);
        if (toastMessage !== "") {
          setShowSolidDangerToast(true);
        }
        throw new Error("Network response was not ok");
      }
      navigate(routes.SEDTeamMangers);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Add Manager</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDDashBoard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={routes.SEDTeamMangers}>Team Managers</Link>
                  </li>
                  <li className="breadcrumb-item active">Add </li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}

          {/* Row */}
          <div className="row justify-content-center">
            <div className="col-sm-12 d-flex justify-content-center">
              {/* Add manager */}
              <div
                className="card w-100"
                style={{
                  maxWidth: "900px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  borderRadius: "10px",
                }}
              >
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 mb-3">
                      <div className="col-12 col-md-6">
                        <label className="form-label">Team Name</label>
                        <input
                          type="text"
                          className={`form-control ${
                            errorMessage.name ? "is-invalid" : ""
                          }`}
                          name="name"
                          placeholder="Team Name"
                          onChange={(e) => {
                            setManagerName(e.target.value);
                          }}
                          value={managerName}
                          required
                        />
                        {errorMessage.name && (
                          <div className="invalid-feedback">
                            {errorMessage.name[0]}
                          </div>
                        )}
                      </div>
                      {/* <div style={{ width: "28%" }}>
                        <label className="form-label">Team Type</label>
                        <Select
                          value={selectedTeamType}
                          onChange={handleTeamTypeChange}
                          options={teamTypeOptions}
                          placeholder="Select a team Type"
                          required
                        />
                      </div> */}
                    </div>

                    <div className="form-group dual-list-box-container">
                      <label className="form-label">Managers </label>
                      <DualListBox
                        options={teamManagers}
                        selected={chosenTeamManagers}
                        onChange={handleTeamManagerChange}
                      />
                    </div>
                    {/* <div className="form-group dual-list-box-container">
                      <label className="form-label">Team Members</label>
                      <DualListBox
                        options={teamMembers}
                        selected={chosenTeamMembers}
                        onChange={handleTeamMembersChange}
                      />
                    </div> */}
                    <div className="modal-footer">
                      <Link
                        className="btn btn-primary"
                        type="submit"
                        to={routes.SEDTeamMangers}
                        style={{
                          backgroundColor: "lightcoral",
                          color: "white",
                          marginRight: "5px",
                        }}
                      >
                        Cancel
                      </Link>
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <i className="spinner-border spinner-border-sm"></i>
                        ) : (
                          <>Save</>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              {/* /Add Group */}
            </div>
          </div>
          {/* /Row */}
          <Toast
            show={showSolidDangerToast}
            onClose={handleSolidDangerToastClose}
            id="solidDangerToast"
            className="colored-toast bg-danger text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
          <Toast
            show={showSolidSuccessToast}
            onClose={handleSolidSuccessToastClose}
            id="solidSuccessToast"
            className="colored-toast bg-success text-fixed-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{
              position: "fixed",
              top: "20px",
              right: "20px",
              zIndex: 1050,
            }}
          >
            <Toast.Body>{toastMessage}</Toast.Body>
          </Toast>
        </div>
      </div>
    </div>
  );
};

export default AddTeamManager;
